import { Table } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export const TreeHeader: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Table.Thead>
      <Table.Tr>
        <Table.Th w="2%" />
        <Table.Th w="76%">{t('FILE_TREE.TREE_HEADER.NAME')}</Table.Th>
        <Table.Th w="10%">{t('FILE_TREE.TREE_HEADER.LAST_MODIFIED')}</Table.Th>
        <Table.Th w="10%">{t('FILE_TREE.TREE_HEADER.SIZE')}</Table.Th>
        <Table.Th w="2%" />
      </Table.Tr>
    </Table.Thead>
  );
};
